const GetSum = (total, num) => {
  return total + num;
};

export default GetSum;
